import * as React from 'react'
import classNames from 'classnames'

import Paragraph from 'content-components/_Primatives/Paragraph'
import style from './style.scss'

type Props = {
  ansiVersion?: 'level1' | 'level3'
} & React.HTMLAttributes<HTMLDivElement>

function ANSIComplianceLogo({ className, ansiVersion = 'level1' }: Props) {
  const ansiText = {
    level1: ['#0994', 'ASTM E2659', 'Certificate Issuer'],
    level3: ['#0994', 'ISO/IEC 17024', 'Personnel Certification Program'],
  }

  return (
    <div className={classNames(style.wrapper, className)}>
      <div className={style.logo}>
        {ansiText[ansiVersion].map((item) => (
          <Paragraph key={item} className={style.text} small>
            {item}
          </Paragraph>
        ))}
      </div>
    </div>
  )
}

export default ANSIComplianceLogo
